import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { range, Observable } from 'rxjs';
import { map, filter, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.css'],
})
export class PaginacaoComponent implements OnInit, OnChanges {
  @Input() deslocamento = 0;
  @Input() range = 2;
  @Input() paginaAtual: number;
  @Input() totalPaginas: number;
  paginas: Observable<number[]>;

  @Output() mudouPagina: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.geraArrayPaginas(/* this.deslocamento */);
  }

  ngOnChanges() {
    this.geraArrayPaginas(/* this.deslocamento */);
  }

  /**
   * Gera Array de páginas navegáveis.
   * @param deslocamento Desloca número de páginas.
   */
  geraArrayPaginas(/* deslocamento: number */) {
    this.paginas = range(-this.range, this.range * 2 + 1).pipe(
      map((deslocamento) => this.paginaAtual + deslocamento),
      filter((numeroPagina) => this.validaNumeroPagina(numeroPagina, this.totalPaginas)),
      toArray(),
    );
  }

  /**
   * Seleciona a página em questão.
   * @param pagina Número da página selecionável.
   * @param event Evento pertinente a seleção de página.
   */
  selecionaPagina(pagina: number, event: Event) {
    this.cancelaEvento(event);
    if (this.validaNumeroPagina(pagina, this.totalPaginas)) {
      this.mudouPagina.emit(pagina);
    }
  }

  /**
   * Valida número de páginas.
   * @param pagina Número da página.
   * @param totalPaginas Número total de páginas.
   * @returns Verdadeiro se número de página é menor que total de página.
   */
  validaNumeroPagina(pagina: number, totalPaginas: number): boolean {
    return pagina > 0 && pagina <= totalPaginas;
  }

  /**
   * Cancela eventos.
   * @param event Evento a ser cancelado.
   */
  cancelaEvento(event: Event) {
    event.preventDefault();
  }
}
